import { TradeFormErrors, TradeFormTouched } from '../Types'

export const getError = (fieldName: keyof TradeFormErrors, errors: TradeFormErrors, touched: TradeFormTouched) => {
  const error = errors[fieldName]
  return error && touched[fieldName] ? { content: error } : null
}
